import React from 'react';
import { getConstant } from '../../../../utils/constants';
import Tag from '../../../../components/Display/Tag';

function InternalResourceItem({ resource, handleClickResource }) {
  return (
    <div className="flex flex-row items-center py-5 px-3 gap-x-5 cursor-pointer hover:bg-slate-100  h-44 shadow-xl ">
      <div
        className="flex flex-row items-center py-5 px-3 gap-x-5 cursor-pointer hover:bg-slate-100 w-full h-44"
        onClick={handleClickResource}>
        <div className="flex flex-col justify-around h-full w-full">
          <div className="flex flex-col gap-y-1">
            <div className="text-xl font-bold text-slate-700 ">{resource.title}</div>
            <div className="text-sm  text-slate-700 ">{resource.author}</div>
          </div>
          <div className="flex flex-row gap-x-3">
            <Tag
              tag={{
                label: getConstant('solarys.resourceTypes', resource.type).label,
                icon: 'star',
                bgColor: 'bg-green-700'
              }}
            />

            <Tag
              tag={{
                label: getConstant('solarys.cities', resource.city).label,
                icon: 'location',
                bgColor: 'bg-purple-800'
              }}
            />
            {resource.public_list.map((o, key) => (
              <Tag
                key={key}
                tag={{
                  label: o.label,
                  icon: 'man',
                  bgColor: 'bg-yellow-500'
                }}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default InternalResourceItem;
